import { media } from '@gem/call/Removable/packages/permissions/permissions';
import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

export const getAudioPermission = async (withAlert = true): Promise<boolean> => {
  const hasAudioPermission = await media.getAudioPermission();

  if (!hasAudioPermission && withAlert) {
    popupsTasks.showAlert(t('calls_no_microphone_permissions'));

    return false;
  } else if (!hasAudioPermission) {
    return false;
  }

  return true;
};
